// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"13c474794bc5b437","487":"c5c7d104ff06b1f8","868":"d39272c8614854c6","921":"87ebb5010930f5af"}[chunkId] + ".js";
};